import { ConversationPanelCloseButton } from "./ConversationPanelCloseButton";
import { ConversationPanelFullscreenButton } from "./ConversationPanelFullscreenButton";
import { ConversationPanelToggleButton } from "./ConversationPanelToggleButton";
import { DismissableBanner } from "./DismissableBanner";
import { DockToggleButton } from "./DockToggleButton";
import {
  useBannersState,
  useDockState,
  useLeftSidebarState,
} from "./hooks/useCircleAIShell";
import { useDock } from "./hooks/useDock";
import { useShellSidebar } from "./hooks/useShellSidebar";
import { Layout } from "./Layout";
import { PanelCloseButton } from "./PanelCloseButton";
import { PanelResizeHandle } from "./PanelResizeHandle";
import { PanelTriggerButton } from "./PanelTriggerButton";
import { Provider } from "./Provider";
import { SidebarResizeHandle } from "./SidebarResizeHandle";
import { SidebarTriggerButton } from "./SidebarTriggerButton";

export const CircleAIAppShell = {
  Layout,
  Provider,
  DismissableBanner,
  DockToggleButton,
  SidebarTriggerButton,
  SidebarResizeHandle,
  PanelCloseButton,
  PanelResizeHandle,
  PanelTriggerButton,
  ConversationPanelToggleButton,
  ConversationPanelFullscreenButton,
  ConversationPanelCloseButton,
  useDockState,
  useLeftSidebarState,
  useBannersState,
  useDock,
  useShellSidebar,
};
